'use strict';

angular.module('enervexSalesappApp').factory('HubspotDeal', function ($resource) {
	return $resource('/api/accounts/:accountId/jobs/:jobId/hubspot-deal/:action', {
		accountId: '@accountId',
		jobId: '@jobId'
	},
	{
		// {configured, hubspotDeal, proposals}
		get: {
			method: 'GET'
		},
		// {proposal, version, amount} -- prices one proposal at one version
		proposalAmount: {
			method: 'GET',
			params: {
				action: 'proposal-amount'
			}
		},
		save: {
			method: 'PUT'
		},
		sync: {
			method: 'POST',
			params: {
				action: 'sync'
			}
		},
		searchContacts: {
			method: 'GET',
			isArray: true,
			params: {
				action: 'contacts'
			}
		},
		createContact: {
			method: 'POST',
			params: {
				action: 'contacts'
			}
		}
	});
});
